@if (message != null) {
  <div [attr.class]="cssClass" [attr.id]="id" [style.margin-top]="marginTop" [style.margin-right]="marginRight" [style.margin-bottom]="marginBottom" [style.margin-left]="marginLeft">
    <span [class]="size" [ngStyle]="{'color': color}" [innerHtml]="message"></span>
  </div>
}